module.exports = __webpack_public_path__ + "static/img/8.8cc0121.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/aboutus/8.jpg
// module id = aTCC
// module chunks = 1